
import {API_BASE_URL} from "../config/config";
import {useNavigate} from "react-router-dom";
import {useUser} from "../Contexts/AuthenticatedUserContext";
import {useEffect} from "react";
import axios from "axios";

/**
 * Logout component
 */

const Logout = () => {

    const navigate = useNavigate();
    const {logout} = useUser();

    useEffect(() => {
        const handleLogout = async () => {
            try {
                const response = await axios.post(`${API_BASE_URL}/api/logout`, {}, { withCredentials: true });

                if (response.status === 200) {
                    console.log(response);
                } else {
                    console.error('Logout fehlgeschlagen.');
                }

            } catch (err) {
                console.error('Fehler beim Logout:', err);
            } finally {
                // clear user data via user context regardless of success or failure
                logout();
                localStorage.setItem('isAuthenticated', 'false');
                // redirect to login page
                navigate('/login');
            }
        };
        handleLogout();
    }, [logout, navigate]);

    return (
        <div>
        </div>
    )

}

export default Logout
